/* =============================================================================
   LYSIS — ESPACE CSE / CE
   Portail par mot de passe, fiches produit en modale, bon de commande calculé.
   ============================================================================= */

(function () {
  'use strict';

  var racine = document.querySelector('[data-ce]');
  if (!racine) return;

  var CLE = 'lysis-ce-acces';

  /* ---------------------------------------------------------------------------
     Utilitaires
     --------------------------------------------------------------------------- */

  /* Les prix rendus par Liquid passent par le filtre money : les totaux
     calculés en JS doivent suivre exactement le même format de boutique,
     sans quoi « €33,50 » côtoierait « 33,50 € » sur la même page. */
  var FORMAT_MONNAIE = racine.getAttribute('data-monnaie') || '{{amount_with_comma_separator}} €';

  var SEPARATEURS = {
    amount: [2, ',', '.'],
    amount_no_decimals: [0, ',', '.'],
    amount_with_comma_separator: [2, '.', ','],
    amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_apostrophe_separator: [2, "'", '.'],
    amount_no_decimals_with_space_separator: [0, ' ', ''],
    amount_with_space_separator: [2, ' ', ','],
    amount_with_period_and_space_separator: [2, ' ', '.']
  };

  function euros(cents) {
    var trouve = false;
    var rendu = FORMAT_MONNAIE.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, cle) {
      var regle = SEPARATEURS[cle];
      if (!regle) return '';
      trouve = true;
      var parties = (cents / 100).toFixed(regle[0]).split('.');
      parties[0] = parties[0].replace(/\B(?=(\d{3})+(?!\d))/g, regle[1]);
      return parties.join(regle[2]);
    });
    return trouve ? rendu : (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* Accents retirés pour que « creme » trouve « Crème ». */
  var DIACRITIQUES = new RegExp('[\\u0300-\\u036f]', 'g');

  function normaliser(texte) {
    return (texte || '').toLowerCase().normalize('NFD').replace(DIACRITIQUES, '');
  }

  function empreinte(texte) {
    if (!window.crypto || !window.crypto.subtle) return Promise.resolve(null);
    var octets = new TextEncoder().encode(texte);
    return window.crypto.subtle.digest('SHA-256', octets).then(function (buffer) {
      return Array.prototype.map
        .call(new Uint8Array(buffer), function (o) {
          return o.toString(16).padStart(2, '0');
        })
        .join('');
    });
  }

  function lire(stockage, cle) {
    try {
      return window[stockage].getItem(cle);
    } catch (err) {
      return null;
    }
  }

  function ecrire(stockage, cle, valeurStockee) {
    try {
      if (valeurStockee === null) window[stockage].removeItem(cle);
      else window[stockage].setItem(cle, valeurStockee);
    } catch (err) {
      /* navigation privée : sans conséquence */
    }
  }

  /* ---------------------------------------------------------------------------
     0. Statistiques de visite
     Chaque événement part vers le script Google (champ « Adresse de réception »)
     qui l'inscrit dans un classeur. Anonyme : un identifiant tiré au hasard
     par navigateur, jamais de nom ni d'e-mail. Les appareils passés par
     l'accès administrateur, et l'éditeur de thème, ne sont pas comptés.
     --------------------------------------------------------------------------- */

  var adresseScript = (racine.getAttribute('data-endpoint') || '').trim();
  var CLE_VISITEUR = 'lysis-ce-visiteur';
  var CLE_ADMIN_APPAREIL = 'lysis-ce-admin';
  var CLE_ADMIN_SESSION = 'lysis-ce-admin-cle';
  /* Copie en mémoire : si le navigateur refuse le sessionStorage, le tableau
     de bord doit quand même pouvoir se rouvrir sans se reconnecter. */
  var cleAdmin = lire('sessionStorage', CLE_ADMIN_SESSION);

  function identifiant() {
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  var visiteur = lire('localStorage', CLE_VISITEUR);
  if (!visiteur) {
    visiteur = identifiant();
    ecrire('localStorage', CLE_VISITEUR, visiteur);
  }
  var session = lire('sessionStorage', 'lysis-ce-session');
  if (!session) {
    session = identifiant();
    ecrire('sessionStorage', 'lysis-ce-session', session);
  }

  function appareil() {
    var tactile = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (window.innerWidth < 768) return 'mobile';
    return tactile ? 'tablette' : 'ordinateur';
  }

  /* Navigateur de Claude (application de bureau : « Claude/x.y » dans la
     signature) et navigateurs pilotés par un robot : jamais comptés. */
  var NAVIGATEUR_ROBOT =
    /\bClaude\/|ClaudeBot|Claude-User|HeadlessChrome|Googlebot|bingbot|crawler|spider/i.test(navigator.userAgent || '') ||
    navigator.webdriver === true;

  /* Appareil admin : gardé en mémoire en plus du localStorage, pour le cas
     où le navigateur refuse ou efface son stockage. Le script Google exclut
     aussi, de son côté, les identifiants passés par l'accès admin. */
  var appareilAdmin = lire('localStorage', CLE_ADMIN_APPAREIL) === '1';

  function suiviActif() {
    return (
      !!adresseScript &&
      !NAVIGATEUR_ROBOT &&
      !appareilAdmin &&
      lire('localStorage', CLE_ADMIN_APPAREIL) !== '1' &&
      !(window.Shopify && window.Shopify.designMode)
    );
  }

  function infosSuivi(infos) {
    var d = { visiteur: visiteur, session: session, appareil: appareil() };
    for (var k in infos) d[k] = infos[k];
    return d;
  }

  function envoyer(d) {
    var corps = JSON.stringify(d);
    /* sendBeacon survit au départ vers le paiement ; sinon fetch keepalive */
    if (navigator.sendBeacon && navigator.sendBeacon(adresseScript, corps)) return;
    try {
      fetch(adresseScript, { method: 'POST', mode: 'no-cors', keepalive: true, body: corps });
    } catch (err) {}
  }

  function suivre(type, infos) {
    if (!suiviActif()) return;
    var d = infosSuivi(infos || {});
    d.action = 'stat';
    d.type = type;
    envoyer(d);
  }

  /* En direct : tant que le catalogue est ouvert et l'onglet au premier plan,
     un signal part toutes les 45 s avec ce que la personne regarde. Onglet
     masqué ou page quittée : signal de départ, elle sort de la vue en direct. */
  var etatLive = 'Parcourt le catalogue';
  var dernierSignal = 0;
  var debutSession = parseInt(lire('sessionStorage', 'lysis-ce-debut'), 10);
  if (!debutSession) {
    debutSession = Date.now();
    ecrire('sessionStorage', 'lysis-ce-debut', String(debutSession));
  }

  function catalogueOuvert() {
    var bloc = racine.querySelector('[data-ce-contenu]');
    return !!bloc && !bloc.hidden;
  }

  function signalerPresence(action) {
    if (!suiviActif() || !catalogueOuvert()) return;
    dernierSignal = Date.now();
    envoyer(infosSuivi({ action: action || 'ping', etat: etatLive, debut: debutSession }));
  }

  function changerEtat(texte) {
    etatLive = texte;
    /* Pas plus d'un signal toutes les 8 s : le suivant reprendra l'état */
    if (Date.now() - dernierSignal > 8000) signalerPresence();
  }

  setInterval(function () {
    if (document.visibilityState === 'visible') signalerPresence();
  }, 45000);
  document.addEventListener('visibilitychange', function () {
    signalerPresence(document.visibilityState === 'visible' ? 'ping' : 'depart');
  });
  window.addEventListener('pagehide', function () {
    signalerPresence('depart');
  });

  function nomProduit(handle) {
    var champ = racine.querySelector('[data-ce-qte][data-handle="' + handle + '"]');
    return champ ? champ.getAttribute('data-produit') : handle;
  }

  /* ---------------------------------------------------------------------------
     1. Portail d'accès
     --------------------------------------------------------------------------- */

  var portail = racine.querySelector('[data-ce-portail]');
  var contenu = racine.querySelector('[data-ce-contenu]');
  var attendue = racine.getAttribute('data-empreinte') || '';
  var sel = racine.getAttribute('data-sel') || '';
  var duree = parseInt(racine.getAttribute('data-duree'), 10) || 30;

  /* Annonce temporaire (précommande des calendriers) : popup une fois par
     visite à l'ouverture du catalogue, rappel au-dessus du total du bon.
     La date de fin, saisie « AAAA-MM-JJ HH:MM » à l'heure de Paris, est
     convertie en instant quel que soit le fuseau du visiteur. */
  var annonce = racine.querySelector('[data-ce-annonce]');
  var annonceRappel = racine.querySelector('[data-ce-annonce-rappel]');
  var CLE_ANNONCE = 'lysis-ce-annonce-vue';

  function finAnnonce() {
    var m = annonce ? (annonce.getAttribute('data-fin') || '').match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/) : null;
    if (!m) return null;
    var heure = m[4] !== undefined ? +m[4] : 23;
    var minute = m[5] !== undefined ? +m[5] : 59;
    var commeUtc = Date.UTC(+m[1], +m[2] - 1, +m[3], heure, minute, 59);
    try {
      var instant = new Date(commeUtc);
      var paris = new Date(instant.toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
      var utc = new Date(instant.toLocaleString('en-US', { timeZone: 'UTC' }));
      return commeUtc - (paris - utc);
    } catch (err) {
      return commeUtc - 3600000;
    }
  }

  function annonceActive() {
    var fin = finAnnonce();
    return fin !== null && Date.now() <= fin;
  }

  function fermerAnnonce() {
    if (annonce) annonce.hidden = true;
  }

  function montrerAnnonce() {
    if (!annonceActive()) return;
    if (annonceRappel) annonceRappel.hidden = false;
    if (lire('sessionStorage', CLE_ANNONCE) === '1') return;
    ecrire('sessionStorage', CLE_ANNONCE, '1');
    annonce.hidden = false;
    var bouton = annonce.querySelector('[data-ce-annonce-fermer]');
    if (bouton) bouton.focus();
  }

  if (annonce) {
    annonce.addEventListener('click', function (ev) {
      if (ev.target === annonce || ev.target.closest('[data-ce-annonce-fermer]')) fermerAnnonce();
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') fermerAnnonce();
    });
  }

  function ouvrir() {
    if (portail) portail.hidden = true;
    if (contenu) contenu.hidden = false;
    montrerAnnonce();
    /* Une visite = une session de navigation sur le catalogue déverrouillé */
    if (lire('sessionStorage', 'lysis-ce-visite') !== '1') {
      ecrire('sessionStorage', 'lysis-ce-visite', '1');
      suivre('visite');
    }
    signalerPresence();
  }

  function memoriser() {
    try {
      window.localStorage.setItem(
        CLE,
        JSON.stringify({ e: attendue, jusqu: Date.now() + duree * 86400000 })
      );
    } catch (err) {
      /* navigation privée : on ne mémorise pas, ce n'est pas bloquant */
    }
  }

  function dejaAutorise() {
    try {
      var brut = window.localStorage.getItem(CLE);
      if (!brut) return false;
      var etat = JSON.parse(brut);
      return etat && etat.e === attendue && etat.jusqu > Date.now();
    } catch (err) {
      return false;
    }
  }

  if (!portail || dejaAutorise()) ouvrir();

  if (portail) {
    var formPortail = portail.querySelector('form');
    var champMdp = portail.querySelector('[data-ce-mdp]');
    var erreurMdp = portail.querySelector('[data-ce-portail-erreur]');

    if (formPortail) {
      formPortail.addEventListener('submit', function (ev) {
        ev.preventDefault();
        erreurMdp.hidden = true;
        var saisie = (champMdp.value || '').trim().toLowerCase();
        if (!saisie) return;

        empreinte(saisie + sel).then(function (hex) {
          if (hex === null) {
            erreurMdp.textContent =
              "Votre navigateur ne permet pas la vérification du mot de passe. Essayez un autre navigateur.";
            erreurMdp.hidden = false;
            return;
          }
          if (hex === attendue) {
            memoriser();
            suivre('acces');
            ouvrir();
            return;
          }

          /* Autre mot de passe : peut-être l'accès administrateur, que seul le
             script Google connaît. Il répond par les statistiques, ou par un
             refus (qu'il compte alors comme mot de passe erroné). */
          if (!adresseScript) return refuser();
          var boutonPortail = formPortail.querySelector('button[type="submit"]');
          var libellePortail = boutonPortail.textContent;
          boutonPortail.disabled = true;
          boutonPortail.textContent = 'Vérification…';

          demanderStats(saisie, 30, true)
            .then(function (stats) {
              cleAdmin = saisie;
              appareilAdmin = true;
              ecrire('sessionStorage', CLE_ADMIN_SESSION, saisie);
              ecrire('localStorage', CLE_ADMIN_APPAREIL, '1');
              memoriser();
              ouvrir();
              ouvrirAdmin(stats);
            })
            .catch(function (erreur) {
              refuser(erreur && erreur.message === 'trop_de_tentatives');
            })
            .then(function () {
              boutonPortail.disabled = false;
              boutonPortail.textContent = libellePortail;
            });
        });

        function refuser(bloque) {
          erreurMdp.textContent = bloque
            ? 'Trop de tentatives. Réessayez dans un quart d’heure.'
            : 'Mot de passe incorrect. Vérifiez auprès de votre référent CSE.';
          erreurMdp.hidden = false;
          champMdp.select();
        }
      });
    }
  }

  /* ---------------------------------------------------------------------------
     2. Recherche dans le catalogue
     --------------------------------------------------------------------------- */

  var recherche = racine.querySelector('[data-ce-recherche]');
  var compte = racine.querySelector('[data-ce-compte]');
  var videRecherche = racine.querySelector('[data-ce-vide]');
  var cartes = Array.prototype.slice.call(racine.querySelectorAll('.ce-produit[data-ce-ouvrir]'));
  var familles = Array.prototype.slice.call(racine.querySelectorAll('[data-ce-famille]'));

  function filtrer() {
    var q = normaliser(recherche.value.trim());
    var visibles = 0;

    cartes.forEach(function (carte) {
      var ok = !q || normaliser(carte.getAttribute('data-ce-texte')).indexOf(q) !== -1;
      carte.hidden = !ok;
      if (ok) visibles++;
    });

    familles.forEach(function (famille) {
      var reste = famille.querySelector('.ce-produit[data-ce-ouvrir]:not([hidden])');
      famille.hidden = !reste;
    });

    if (compte) {
      compte.textContent = q
        ? visibles + (visibles > 1 ? ' produits trouvés' : ' produit trouvé')
        : '';
    }
    if (videRecherche) videRecherche.hidden = visibles !== 0;
  }

  /* Termes recherchés : notés après une pause de frappe, une fois par session */
  var minuteurRecherche;
  var termesNotes = {};

  if (recherche) {
    recherche.addEventListener('input', filtrer);
    recherche.addEventListener('input', function () {
      clearTimeout(minuteurRecherche);
      minuteurRecherche = setTimeout(function () {
        var terme = normaliser(recherche.value.trim());
        if (terme.length < 3 || termesNotes[terme]) return;
        termesNotes[terme] = true;
        suivre('recherche', { detail: terme });
      }, 1500);
    });
  }

  /* ---------------------------------------------------------------------------
     3. Bon de commande — calculs
     --------------------------------------------------------------------------- */

  var form = racine.querySelector('[data-ce-form]');
  var quantites = Array.prototype.slice.call(racine.querySelectorAll('[data-ce-qte]'));
  var sommeEl = racine.querySelector('[data-ce-somme]');
  var barreEl = racine.querySelector('[data-ce-barre-somme]');
  var nbEl = racine.querySelector('[data-ce-nb]');
  var flottantNb = racine.querySelector('[data-ce-flottant-nb]');
  var champCse = racine.querySelector('[name="entreprise"]');
  var lignePort = racine.querySelector('[data-ce-ligne-port]');
  var portEl = racine.querySelector('[data-ce-port]');
  var noteLivraison = racine.querySelector('[data-ce-note-livraison]');
  var noteLivraisonGratuite = noteLivraison ? noteLivraison.textContent : '';

  /* Certains CSE (Bordeaux, Paris) sont livrés avec des frais de port :
     montant en centimes porté par l'option de la liste (data-frais-port).
     Au-delà du seuil (data-port-offert, en centimes, sur le montant des
     articles), le port est offert : la commande repart comme celle des
     autres CSE (code de livraison gratuite, valeur « oui » pour ShipWith). */
  function optionCse() {
    return champCse && champCse.options ? champCse.options[champCse.selectedIndex] : null;
  }

  function seuilPortOffert() {
    var option = optionCse();
    return option ? parseInt(option.getAttribute('data-port-offert'), 10) || 0 : 0;
  }

  function fraisPort(articlesCentimes) {
    var option = optionCse();
    var port = option ? parseInt(option.getAttribute('data-frais-port'), 10) || 0 : 0;
    var seuil = seuilPortOffert();
    if (seuil && articlesCentimes >= seuil) return 0;
    return port;
  }

  if (champCse) champCse.addEventListener('change', recalculer);

  /* Stock Shopify de la déclinaison choisie (data-stock sur l'option, ou sur
     le champ pour un produit sans déclinaison). Absent quand le stock n'est
     pas suivi ou que la vente continue en rupture (précommandes) : pas de
     plafond. */
  function stockLigne(champ) {
    var ligne = champ.closest('tr');
    var select = ligne ? ligne.querySelector('[data-ce-variante]') : null;
    var source = select ? select.options[select.selectedIndex] : champ;
    var stock = source ? source.getAttribute('data-stock') : null;
    return stock === null ? null : parseInt(stock, 10) || 0;
  }

  /* Ramène la quantité au stock disponible et le signale sous le champ.
     Toutes les façons d'ajouter (saisie, +/−, fiche, ajout rapide) passent
     par recalculer(), donc par ce plafond. */
  function limiterAuStock(champ) {
    var stock = stockLigne(champ);
    var cellule = champ.closest('.ce-col-qte');
    var alerte = cellule ? cellule.querySelector('[data-ce-stock-alerte]') : null;
    if (stock === null) {
      champ.removeAttribute('max');
    } else {
      champ.max = String(stock);
    }

    var q = parseInt(champ.value, 10);
    var depasse = stock !== null && q > stock;
    if (depasse) champ.value = stock > 0 ? String(stock) : '';

    if (!cellule) return depasse;
    if (depasse) {
      if (!alerte) {
        alerte = document.createElement('span');
        alerte.className = 'ce-stock-alerte';
        alerte.setAttribute('data-ce-stock-alerte', '');
        alerte.setAttribute('role', 'status');
        cellule.appendChild(alerte);
      }
      alerte.textContent = stock > 1 ? 'Plus que ' + stock + ' en stock' : stock === 1 ? 'Plus qu’1 en stock' : 'Épuisé';
      clearTimeout(alerte._ceMinuteur);
      alerte._ceMinuteur = setTimeout(function () {
        alerte.remove();
      }, 4000);
    }
    return depasse;
  }

  function recalculer() {
    var somme = 0;
    var articles = 0;

    quantites.forEach(function (champ) {
      limiterAuStock(champ);
      var q = parseInt(champ.value, 10);
      var pu = parseInt(champ.getAttribute('data-pu'), 10) || 0;
      var ligne = champ.closest('tr');
      var cellule = ligne ? ligne.querySelector('[data-ce-total]') : null;
      if (!cellule) return;

      if (q > 0) {
        var total = q * pu;
        somme += total;
        articles += q;
        cellule.textContent = euros(total);
        cellule.classList.remove('ce-vide');
      } else {
        cellule.textContent = '—';
        cellule.classList.add('ce-vide');
      }
    });

    var port = fraisPort(somme);
    var seuil = seuilPortOffert();
    if (lignePort) lignePort.hidden = !port;
    if (portEl && port) portEl.textContent = euros(port);
    if (noteLivraison) {
      if (port) {
        noteLivraison.textContent =
          'Commande groupée : livraison auprès de votre CSE, ' +
          euros(port) +
          ' de frais de port' +
          (seuil ? ' (offerts dès ' + euros(seuil) + ' d’achats).' : '.');
      } else if (seuil) {
        noteLivraison.textContent = 'Commande groupée : livraison auprès de votre CSE offerte dès ' + euros(seuil) + ' d’achats.';
      } else {
        noteLivraison.textContent = noteLivraisonGratuite;
      }
    }
    if (articles > 0) somme += port;

    if (sommeEl) sommeEl.textContent = euros(somme);
    if (barreEl) barreEl.textContent = euros(somme);
    if (nbEl) nbEl.textContent = String(articles);
    if (flottantNb) {
      flottantNb.textContent = String(articles);
      flottantNb.hidden = articles === 0;
    }
    if (apercu && !apercu.hidden) remplirApercu();
    memoriserBon();
  }

  /* Le bon est gardé le temps de la visite (onglet) : un rechargement de
     page ne vide pas la sélection. Les produits devenus épuisés n'ont plus
     de ligne et sont ignorés. */
  var CLE_BON = 'lysis-ce-bon';

  function memoriserBon() {
    var etat = {};
    quantites.forEach(function (champ) {
      var q = parseInt(champ.value, 10);
      if (!(q > 0)) return;
      var select = champ.closest('tr') ? champ.closest('tr').querySelector('[data-ce-variante]') : null;
      etat[champ.getAttribute('data-handle')] = [q, select ? select.value : ''];
    });
    try {
      window.sessionStorage.setItem(CLE_BON, JSON.stringify(etat));
    } catch (err) {}
  }

  function oublierBon() {
    try {
      window.sessionStorage.removeItem(CLE_BON);
    } catch (err) {}
  }

  function restaurerBon() {
    var etat = null;
    try {
      etat = JSON.parse(window.sessionStorage.getItem(CLE_BON) || 'null');
    } catch (err) {}
    if (!etat) return;
    quantites.forEach(function (champ) {
      var ligne = etat[champ.getAttribute('data-handle')];
      if (!ligne) return;
      champ.value = String(ligne[0]);
      var select = champ.closest('tr') ? champ.closest('tr').querySelector('[data-ce-variante]') : null;
      if (select && ligne[1]) {
        select.value = ligne[1];
        if (select.value !== ligne[1]) select.selectedIndex = 0;
      }
    });
  }

  quantites.forEach(function (champ) {
    champ.addEventListener('input', recalculer);
  });

  /* Une déclinaison peut avoir son propre prix (tailles, contenances) : le
     tarif unitaire de la ligne suit le choix du salarié. */
  function appliquerVariante(select) {
    var ligne = select.closest('tr');
    if (!ligne) return;
    var champ = ligne.querySelector('[data-ce-qte]');
    var option = select.options[select.selectedIndex];
    if (!champ || !option) return;

    var pu = option.getAttribute('data-pu');
    if (pu) champ.setAttribute('data-pu', pu);

    var cellulePu = ligne.querySelector('[data-ce-pu-ce]');
    if (cellulePu && pu) cellulePu.textContent = euros(parseInt(pu, 10));

    var public_ = option.getAttribute('data-public');
    var cellulePublic = ligne.querySelector('[data-ce-pu-public]');
    if (cellulePublic && public_) cellulePublic.textContent = euros(parseInt(public_, 10));
  }

  restaurerBon();

  Array.prototype.slice.call(racine.querySelectorAll('[data-ce-variante]')).forEach(function (select) {
    appliquerVariante(select);
    select.addEventListener('change', function () {
      appliquerVariante(select);
      recalculer();
    });
  });

  recalculer();

  /* ---------------------------------------------------------------------------
     4. Fiche produit en modale
     --------------------------------------------------------------------------- */

  /* Bouton flottant « Voir mon bon de commande » : masqué quand le bon est
     déjà à l'écran (la barre collante du bon prend le relais). */
  var flottant = racine.querySelector('[data-ce-flottant]');
  var bon = racine.querySelector('.ce-bon');
  if (flottant && bon && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entrees) {
      flottant.classList.toggle('is-cache', entrees[0].isIntersecting);
      if (entrees[0].isIntersecting) fermerApercu(false);
    }).observe(bon);
  }

  /* Aperçu du panier : relu à chaque ouverture depuis les quantités du
     tableau, qui restent la seule source de vérité. */
  var apercu = racine.querySelector('[data-ce-apercu]');
  var apercuListe = apercu ? apercu.querySelector('[data-ce-apercu-liste]') : null;
  var apercuVide = apercu ? apercu.querySelector('[data-ce-apercu-vide]') : null;
  var apercuPied = apercu ? apercu.querySelector('[data-ce-apercu-pied]') : null;
  var apercuNb = apercu ? apercu.querySelector('[data-ce-apercu-nb]') : null;
  var apercuSomme = apercu ? apercu.querySelector('[data-ce-apercu-somme]') : null;

  function remplirApercu() {
    var somme = 0;
    var articles = 0;
    apercuListe.innerHTML = '';

    quantites.forEach(function (champ) {
      var q = parseInt(champ.value, 10);
      if (!(q > 0)) return;
      var pu = parseInt(champ.getAttribute('data-pu'), 10) || 0;
      var ligne = champ.closest('tr');
      var variante = ligne ? ligne.querySelector('[data-ce-variante]') : null;
      somme += q * pu;
      articles += q;

      var li = document.createElement('li');
      li.className = 'ce-apercu__ligne';

      var infos = document.createElement('div');
      var nom = document.createElement('span');
      nom.className = 'ce-apercu__nom';
      nom.textContent = champ.getAttribute('data-produit');
      infos.appendChild(nom);
      if (variante) {
        var detail = document.createElement('span');
        detail.className = 'ce-apercu__detail';
        detail.textContent = variante.value;
        infos.appendChild(detail);
      }
      var prix = document.createElement('span');
      prix.className = 'ce-apercu__detail';
      prix.textContent = euros(pu) + ' l’unité';
      infos.appendChild(prix);

      var qte = document.createElement('div');
      qte.className = 'ce-apercu__qte';
      var nomProduit = champ.getAttribute('data-produit');
      [['-1', '−', 'Retirer un ' + nomProduit], ['+1', '+', 'Ajouter un ' + nomProduit]].forEach(function (d, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = d[1];
        b.setAttribute('aria-label', d[2]);
        b.setAttribute('data-ce-apercu-pas', d[0]);
        b.setAttribute('data-handle', champ.getAttribute('data-handle'));
        if (i === 0) {
          qte.appendChild(b);
          var nb = document.createElement('b');
          nb.textContent = String(q);
          qte.appendChild(nb);
        } else {
          qte.appendChild(b);
        }
      });

      var total = document.createElement('span');
      total.className = 'ce-apercu__prix';
      total.textContent = euros(q * pu);

      li.appendChild(infos);
      li.appendChild(qte);
      li.appendChild(total);
      apercuListe.appendChild(li);
    });

    apercuVide.hidden = articles > 0;
    apercuListe.hidden = articles === 0;
    apercuPied.hidden = articles === 0;
    apercuNb.textContent = articles + (articles > 1 ? ' articles' : ' article');
    apercuSomme.textContent = euros(somme);
  }

  function ouvrirApercu() {
    if (!apercu) return;
    remplirApercu();
    apercu.hidden = false;
    flottant.setAttribute('aria-expanded', 'true');
    var focus = apercu.querySelector('[data-ce-apercu-bon]:not([hidden])');
    (apercuPied.hidden ? apercu.querySelector('.ce-apercu__fermer') : focus).focus();
  }

  function fermerApercu(rendreFocus) {
    if (!apercu || apercu.hidden) return;
    apercu.hidden = true;
    flottant.setAttribute('aria-expanded', 'false');
    if (rendreFocus) flottant.focus();
  }

  if (flottant && apercu) {
    flottant.addEventListener('click', function () {
      if (apercu.hidden) ouvrirApercu();
      else fermerApercu(false);
    });

    apercu.addEventListener('click', function (ev) {
      var pas = ev.target.closest('[data-ce-apercu-pas]');
      if (pas) {
        var champ = racine.querySelector('[data-ce-qte][data-handle="' + pas.getAttribute('data-handle') + '"]');
        if (champ) {
          var nouveau = (parseInt(champ.value, 10) || 0) + parseInt(pas.getAttribute('data-ce-apercu-pas'), 10);
          champ.value = nouveau > 0 ? String(nouveau) : '';
          recalculer();
        }
        return;
      }
      if (ev.target.closest('[data-ce-apercu-fermer]')) fermerApercu(true);
      if (ev.target.closest('[data-ce-apercu-bon]')) fermerApercu(false);
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') fermerApercu(true);
    });

    document.addEventListener('click', function (ev) {
      if (apercu.hidden) return;
      /* Les boutons +/− sont recréés au clic : la cible n'est alors plus dans le document */
      if (!document.contains(ev.target)) return;
      if (apercu.contains(ev.target) || flottant.contains(ev.target)) return;
      if (ev.target.closest('[data-ce-ajout-rapide]')) return;
      fermerApercu(false);
    });
  }

  var modale = racine.querySelector('[data-ce-modale]');
  var modaleCorps = modale ? modale.querySelector('[data-ce-modale-corps]') : null;
  var declencheur = null;
  var positionAvantFiche = 0;

  function brancherGalerie(portee) {
    var principale = portee.querySelector('[data-ce-image-principale]');
    var vignettes = Array.prototype.slice.call(portee.querySelectorAll('[data-ce-vignette]'));
    if (!principale || !vignettes.length) return;

    vignettes.forEach(function (vignette) {
      vignette.addEventListener('click', function () {
        principale.src = vignette.getAttribute('data-grande');
        principale.alt = vignette.getAttribute('data-alt') || '';
        vignettes.forEach(function (autre) {
          autre.setAttribute('aria-current', autre === vignette ? 'true' : 'false');
        });
      });
    });
  }

  function brancherAjout(portee) {
    var bouton = portee.querySelector('[data-ce-ajouter]');
    if (!bouton) return;

    var handle = bouton.getAttribute('data-ce-ajouter');
    var champQte = portee.querySelector('[data-ce-ajout-qte]');
    var champVariante = portee.querySelector('[data-ce-ajout-variante]');
    var confirmation = portee.querySelector('[data-ce-ajout-ok]');
    var ligne = racine.querySelector('[data-ce-ligne="' + handle + '"]');
    if (!ligne) {
      bouton.disabled = true;
      return;
    }

    /* Le champ quantité de la fiche suit le stock de la déclinaison choisie */
    function plafonnerFiche() {
      var source = champVariante ? champVariante.options[champVariante.selectedIndex] : champQte;
      var stock = source ? source.getAttribute('data-stock') : null;
      if (stock === null) {
        champQte.removeAttribute('max');
        return;
      }
      champQte.max = String(parseInt(stock, 10) || 0);
      if ((parseInt(champQte.value, 10) || 0) > (parseInt(stock, 10) || 0)) champQte.value = stock;
    }
    plafonnerFiche();
    if (champVariante) champVariante.addEventListener('change', plafonnerFiche);
    champQte.addEventListener('input', plafonnerFiche);

    bouton.addEventListener('click', function () {
      var cible = ligne.querySelector('[data-ce-qte]');
      var varianteCible = ligne.querySelector('[data-ce-variante]');
      var ajout = parseInt(champQte.value, 10);
      if (!(ajout > 0)) ajout = 1;

      var voulu = (parseInt(cible.value, 10) || 0) + ajout;
      cible.value = voulu;
      suivre('ajout', {
        reference: handle,
        produit: nomProduit(handle),
        quantite: ajout,
        detail: champVariante ? champVariante.value : ''
      });
      if (varianteCible && champVariante) {
        varianteCible.value = champVariante.value;
        appliquerVariante(varianteCible);
      }

      recalculer();
      ligne.classList.remove('ce-ligne--flash');
      void ligne.offsetWidth;
      ligne.classList.add('ce-ligne--flash');

      if (confirmation) {
        var total = parseInt(cible.value, 10) || 0;
        confirmation.textContent =
          total < voulu
            ? 'Stock limité : ' + total + ' au maximum dans votre bon de commande.'
            : 'Ajouté au bon de commande (' + total + ' au total). Retrouvez-le dans « Voir mon bon de commande ».';
        confirmation.hidden = false;
      }
    });
  }

  function afficherFiche(handle) {
    if (!modale || !modaleCorps) return;
    var gabarit = racine.querySelector('template[data-ce-fiche="' + handle + '"]');
    if (!gabarit) return;

    suivre('fiche', { reference: handle, produit: nomProduit(handle) });
    changerEtat('Regarde : ' + nomProduit(handle));

    modaleCorps.innerHTML = '';
    modaleCorps.appendChild(gabarit.content.cloneNode(true));
    brancherGalerie(modaleCorps);
    brancherAjout(modaleCorps);
    modaleCorps.scrollTop = 0;

    /* showModal() ramène la page en haut : on note la position de lecture
       juste avant, et on la remet aussitôt. Le fond est masqué par le voile
       de la modale, le visiteur ne voit aucun saut. */
    positionAvantFiche = window.scrollY;

    if (typeof modale.showModal === 'function') {
      modale.showModal();
    } else {
      modale.setAttribute('open', '');
    }

    window.scrollTo({ top: positionAvantFiche, left: 0, behavior: 'instant' });
  }

  /* Ajout direct depuis la vignette (produits sans déclinaison) : +1 sur la
     ligne du bon, sans ouvrir la fiche. */
  function ajoutRapide(bouton) {
    var handle = bouton.getAttribute('data-ce-ajout-rapide');
    var ligne = racine.querySelector('[data-ce-ligne="' + handle + '"]');
    var cible = ligne ? ligne.querySelector('[data-ce-qte]') : null;
    if (!cible) return;

    var voulu = (parseInt(cible.value, 10) || 0) + 1;
    cible.value = voulu;
    recalculer();
    var plafonne = (parseInt(cible.value, 10) || 0) < voulu;
    if (!plafonne) suivre('ajout', { reference: handle, produit: nomProduit(handle), quantite: 1 });
    ligne.classList.remove('ce-ligne--flash');
    void ligne.offsetWidth;
    ligne.classList.add('ce-ligne--flash');

    clearTimeout(bouton._ceMinuteur);
    bouton.textContent = plafonne ? 'Stock max (' + cible.value + ')' : 'Ajouté ✓ (' + cible.value + ')';
    bouton.classList.add('is-ajoute');
    bouton._ceMinuteur = setTimeout(function () {
      bouton.textContent = 'Ajouter au panier';
      bouton.classList.remove('is-ajoute');
    }, 1800);

    if (flottant) {
      flottant.classList.remove('is-pulse');
      void flottant.offsetWidth;
      flottant.classList.add('is-pulse');
    }
  }

  racine.addEventListener('click', function (ev) {
    var rapide = ev.target.closest('[data-ce-ajout-rapide]');
    if (rapide && racine.contains(rapide)) {
      ajoutRapide(rapide);
      return;
    }
    var bouton = ev.target.closest('[data-ce-ouvrir]');
    if (!bouton || !racine.contains(bouton)) return;
    declencheur = bouton;
    afficherFiche(bouton.getAttribute('data-ce-ouvrir'));
  });

  if (modale) {
    modale.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-ce-fermer]')) {
        modale.close();
      } else if (ev.target === modale) {
        modale.close();
      }
    });
    /* En refermant une fiche, on remet le visiteur là où il lisait : vider la
       modale raccourcit la page, et rendre le focus au bouton la ferait
       défiler. On restaure donc la position notée à l'ouverture. */
    modale.addEventListener('close', function () {
      modaleCorps.innerHTML = '';
      changerEtat(vueBon && !vueBon.hidden ? 'Sur le bon de commande' : 'Parcourt le catalogue');
      if (declencheur) {
        declencheur.focus({ preventScroll: true });
        declencheur = null;
      }
      window.scrollTo({ top: positionAvantFiche, left: 0, behavior: 'instant' });
    });
  }

  /* ---------------------------------------------------------------------------
     5. Actions du bon
     --------------------------------------------------------------------------- */

  var boutonVider = racine.querySelector('[data-ce-vider]');
  var boutonEnvoyer = racine.querySelector('[data-ce-envoyer]');
  var messageErreur = racine.querySelector('[data-ce-erreur]');
  var ecran = racine.querySelector('[data-ce-ecran]');
  var endpoint = (racine.getAttribute('data-endpoint') || '').trim();
  var courriel = (racine.getAttribute('data-email') || '').trim();
  var codeRemise = (racine.getAttribute('data-code-remise') || '').trim();
  var codeLivraison = (racine.getAttribute('data-code-livraison') || '').trim();

  if (boutonVider) {
    boutonVider.addEventListener('click', function () {
      quantites.forEach(function (champ) {
        champ.value = '';
      });
      recalculer();
      oublierBon();
    });
  }

  function afficherErreur(texte, champ) {
    if (!messageErreur) return;
    messageErreur.textContent = texte;
    messageErreur.hidden = false;
    racine.querySelectorAll('.ce-champ--erreur').forEach(function (c) {
      c.classList.remove('ce-champ--erreur');
    });
    if (champ) {
      var conteneur = champ.closest('.ce-champ');
      if (conteneur) conteneur.classList.add('ce-champ--erreur');
      champ.focus();
    }
    messageErreur.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function collecter() {
    var lignes = [];
    quantites.forEach(function (champ) {
      var q = parseInt(champ.value, 10);
      if (!(q > 0)) return;
      var ligne = champ.closest('tr');
      var variante = ligne ? ligne.querySelector('[data-ce-variante]') : null;
      var pu = parseInt(champ.getAttribute('data-pu'), 10) || 0;
      var option = variante ? variante.options[variante.selectedIndex] : null;
      lignes.push({
        varianteId: parseInt((option || champ).getAttribute('data-variante-id'), 10),
        produit: champ.getAttribute('data-produit'),
        marque: champ.getAttribute('data-marque'),
        reference: champ.getAttribute('data-handle'),
        choix: variante ? variante.value : '',
        quantite: q,
        prixUnitaire: pu / 100,
        total: (q * pu) / 100
      });
    });
    return lignes;
  }

  function valeur(nom) {
    var champ = racine.querySelector('[name="' + nom + '"]');
    return champ ? champ.value.trim() : '';
  }

  function resumeTexte(donnees) {
    var l = [];
    l.push('Bon de commande CSE — ' + donnees.nom);
    l.push('E-mail : ' + donnees.email);
    if (donnees.telephone) l.push('Téléphone : ' + donnees.telephone);
    if (donnees.entreprise) l.push('Entreprise / CSE : ' + donnees.entreprise);
    if (donnees.service) l.push('Service ou site : ' + donnees.service);
    l.push('');
    donnees.lignes.forEach(function (ligne) {
      l.push(
        ligne.quantite +
          ' x ' +
          ligne.produit +
          (ligne.choix ? ' (' + ligne.choix + ')' : '') +
          ' — ' +
          ligne.total.toFixed(2).replace('.', ',') +
          ' EUR'
      );
    });
    l.push('');
    l.push('Articles : ' + donnees.articles);
    if (donnees.port) l.push('Livraison auprès du CSE : ' + donnees.port.toFixed(2).replace('.', ',') + ' EUR');
    l.push('Total : ' + (donnees.total + donnees.port).toFixed(2).replace('.', ',') + ' EUR');
    return l.join('\n');
  }

  function reussite(texte) {
    if (!ecran) return;
    var message = ecran.querySelector('[data-ce-ecran-msg]');
    if (message) message.textContent = texte;
    ecran.hidden = false;
  }

  if (ecran) {
    ecran.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-ce-ecran-retour]') || ev.target === ecran) {
        ecran.hidden = true;
      }
    });
  }

  /* Paiement en ligne : le bon devient un panier Shopify (vidé d'abord, pour
     ne payer que la commande CSE), les codes CSE y sont appliqués, puis la
     salariée part au paiement. Ses coordonnées suivent en attributs de
     commande, pour la livraison groupée. */
  function appelPanier(chemin, corps) {
    var racineBoutique = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(racineBoutique + chemin, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps || {})
    }).then(function (reponse) {
      return reponse.json().then(function (json) {
        if (!reponse.ok) throw new Error(json.description || json.message || 'reponse ' + reponse.status);
        return json;
      });
    });
  }

  function payer(donnees) {
    var libelle = boutonEnvoyer ? boutonEnvoyer.textContent : '';
    if (boutonEnvoyer) {
      boutonEnvoyer.disabled = true;
      boutonEnvoyer.textContent = 'Préparation du paiement…';
    }

    /* CSE livré avec frais de port (Bordeaux, Paris) : pas de code de
       livraison gratuite, et la valeur « frais-port » pour que ShipWith
       propose le tarif à 5 € au lieu de la remise gratuite. ShipWith exige
       la même clé dans toutes ses conditions : seule la valeur change. */
    var proprieteCse = '_Commande CSE';
    var valeurCse = donnees.port ? 'frais-port' : 'oui';
    var proprietes = {};
    proprietes[proprieteCse] = valeurCse;
    var codes = [codeRemise, donnees.port ? '' : codeLivraison].filter(Boolean).join(',');
    /* « Commande CSE » sert de condition à l'app ShipWith : seul ce panier
       voit le mode « Remise en main propre auprès de votre CSE ». */
    var attributs = { 'Commande CSE': 'oui', 'CSE - Nom': donnees.nom };
    attributs[proprieteCse] = valeurCse;
    if (donnees.entreprise) attributs['CSE - Entreprise'] = donnees.entreprise;
    if (donnees.service) attributs['CSE - Service ou site'] = donnees.service;
    if (donnees.telephone) attributs['CSE - Téléphone'] = donnees.telephone;
    attributs['CSE - Livraison'] = donnees.port
      ? 'Auprès du CSE — ' + donnees.port.toFixed(2).replace('.', ',') + ' €'
      : 'Remise gratuite par le CSE';

    appelPanier('cart/clear.js')
      .then(function () {
        return appelPanier('cart/add.js', {
          items: donnees.lignes.map(function (ligne) {
            /* Propriété de ligne lue par ShipWith (« Cart items attribute ») ;
               le « _ » la masque au client dans le panier et au paiement. */
            return { id: ligne.varianteId, quantity: ligne.quantite, properties: proprietes };
          })
        });
      })
      .then(function () {
        return appelPanier('cart/update.js', {
          discount: codes,
          attributes: attributs,
          note: 'Commande CSE' + (donnees.entreprise ? ' — ' + donnees.entreprise : '')
        });
      })
      .then(function () {
        /* Cookies bloqués : Shopify ne retrouve pas le panier d'un appel à
           l'autre, il revient vide et /checkout ne mènerait nulle part. */
        var racineBoutique = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return fetch(racineBoutique + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (reponse) {
            return reponse.json();
          })
          .then(function (panier) {
            if (!panier.item_count) {
              throw new Error(
                'votre navigateur semble bloquer les cookies, indispensables au panier. Autorisez-les pour ce site, ou utilisez un autre navigateur.'
              );
            }
            oublierBon();
            window.location.href = racineBoutique + 'checkout';
          });
      })
      .catch(function (erreur) {
        afficherErreur(
          'Impossible de préparer le paiement' +
            (erreur && erreur.message && erreur.message.indexOf('reponse') !== 0 ? ' : ' + erreur.message : '.') +
            ' Réessayez dans un instant.'
        );
        if (boutonEnvoyer) {
          boutonEnvoyer.disabled = false;
          boutonEnvoyer.textContent = libelle;
        }
      });
  }

  if (boutonEnvoyer && !endpoint && !courriel && !codeRemise) {
    boutonEnvoyer.disabled = true;
    boutonEnvoyer.title = "L'envoi en ligne n'est pas encore configuré.";
  }

  if (form) {
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (messageErreur) messageErreur.hidden = true;

      var champNom = racine.querySelector('[name="nom"]');
      var champEmail = racine.querySelector('[name="email"]');

      if (!champNom.value.trim()) return afficherErreur("Merci d'indiquer votre nom et prénom.", champNom);
      if (!champEmail.checkValidity() || !champEmail.value.trim()) {
        return afficherErreur("Merci d'indiquer une adresse e-mail valide.", champEmail);
      }

      /* Obligatoire : la commande est remise par le CSE de l'entreprise */
      var champEntreprise = racine.querySelector('[name="entreprise"]');
      if (champEntreprise && !champEntreprise.value.trim()) {
        return afficherErreur("Merci de choisir votre CSE dans la liste : c'est lui qui vous remettra la commande.", champEntreprise);
      }

      var lignes = collecter();
      if (!lignes.length) {
        return afficherErreur('Votre commande est vide : indiquez au moins une quantité.');
      }

      var somme = lignes.reduce(function (t, ligne) {
        return t + ligne.total;
      }, 0);

      var donnees = {
        nom: champNom.value.trim(),
        email: champEmail.value.trim(),
        service: valeur('service'),
        telephone: valeur('tel'),
        entreprise: valeur('entreprise'),
        port: fraisPort(Math.round(somme * 100)) / 100,
        piege: valeur('site-web'),
        lignes: lignes,
        articles: lignes.reduce(function (t, ligne) {
          return t + ligne.quantite;
        }, 0),
        total: Math.round(somme * 100) / 100
      };

      if (donnees.piege) return; /* robot */

      changerEtat('Part au paiement');
      suivre('paiement', {
        quantite: donnees.articles,
        montant: donnees.total,
        detail: donnees.entreprise
      });

      if (codeRemise) {
        payer(donnees);
        return;
      }

      if (!endpoint) {
        var sujet = 'Bon de commande CSE — ' + donnees.nom;
        window.location.href =
          'mailto:' +
          encodeURIComponent(courriel) +
          '?subject=' +
          encodeURIComponent(sujet) +
          '&body=' +
          encodeURIComponent(resumeTexte(donnees));
        reussite(
          "Votre logiciel de messagerie s'ouvre avec le récapitulatif : il ne vous reste qu'à envoyer l'e-mail."
        );
        return;
      }

      boutonEnvoyer.disabled = true;
      var libelle = boutonEnvoyer.textContent;
      boutonEnvoyer.textContent = 'Envoi en cours…';

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(donnees)
      })
        .then(function (reponse) {
          if (!reponse.ok) throw new Error('reponse ' + reponse.status);
          /* Google Apps Script repond toujours 200 : l'echec est dans le corps { ok: false } */
          return reponse.text().then(function (texte) {
            var corps = null;
            try {
              corps = JSON.parse(texte);
            } catch (e) {}
            if (corps && corps.ok === false) throw new Error(corps.erreur || 'refus');
          });
        })
        .then(function () {
          reussite(
            'Votre commande a bien été transmise. Un récapitulatif part à ' + donnees.email + '.'
          );
        })
        .catch(function () {
          afficherErreur(
            "L'envoi a échoué. Réessayez dans un instant."
          );
        })
        .then(function () {
          boutonEnvoyer.disabled = false;
          boutonEnvoyer.textContent = libelle;
        });
    });
  }

  /* ---------------------------------------------------------------------------
     6. Deux écrans : catalogue et bon de commande (#bon-de-commande)
     --------------------------------------------------------------------------- */

  var vueCatalogue = racine.querySelector('[data-ce-vue-catalogue]');
  var vueBon = racine.querySelector('[data-ce-vue-bon]');
  var positionCatalogue = 0;

  function afficherVue() {
    if (!vueCatalogue || !vueBon) return;
    var bonDemande = window.location.hash === '#bon-de-commande';
    if (bonDemande === !vueBon.hidden) return;

    if (bonDemande) {
      if (contenu && !contenu.hidden) suivre('bon');
      positionCatalogue = window.scrollY;
      if (typeof fermerApercu === 'function') fermerApercu(false);
    }
    vueCatalogue.hidden = bonDemande;
    vueBon.hidden = !bonDemande;
    changerEtat(bonDemande ? 'Sur le bon de commande' : 'Parcourt le catalogue');
    racine.classList.toggle('is-vue-bon', bonDemande);
    /* Le bon s'ouvre en haut de page : sous l'en-tête collant, son titre serait masqué */
    window.scrollTo({ top: bonDemande ? 0 : positionCatalogue, left: 0, behavior: 'instant' });
  }

  window.addEventListener('hashchange', afficherVue);
  afficherVue();

  /* ---------------------------------------------------------------------------
     7. Accès administrateur : tableau de bord des statistiques
     Le mot de passe admin n'existe que dans le script Google : la page le lui
     transmet, il répond par les chiffres ou par un refus. Gardé le temps de
     l'onglet (sessionStorage), jamais au-delà.
     --------------------------------------------------------------------------- */

  var admin = racine.querySelector('[data-ce-admin]');
  var adminCorps = racine.querySelector('[data-ce-admin-corps]');
  var adminErreur = racine.querySelector('[data-ce-admin-erreur]');
  var adminMaj = racine.querySelector('[data-ce-admin-maj]');
  var adminClasseur = racine.querySelector('[data-ce-admin-classeur]');
  /* Deux déclencheurs : le bouton flottant (parfois recouvert par le bandeau
     cookies sur téléphone) et la barre en haut du catalogue. */
  var adminOuvrir = Array.prototype.slice.call(racine.querySelectorAll('[data-ce-admin-ouvrir]'));

  function montrerDeclencheurs(visible) {
    adminOuvrir.forEach(function (b) {
      b.hidden = !visible;
    });
  }
  var periodes = Array.prototype.slice.call(racine.querySelectorAll('[data-ce-admin-jours]'));
  var joursAdmin = 30;

  function demanderStats(cle, jours, avecSuivi) {
    var d = { action: 'stats', cle: cle, jours: jours };
    if (avecSuivi && suiviActif()) d.suivi = infosSuivi({});
    return appelAdmin(d);
  }

  function appelAdmin(d) {
    d.visiteur = visiteur;
    return fetch(adresseScript, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(d)
    })
      .then(function (reponse) {
        return reponse.text();
      })
      .then(function (texte) {
        var corps = null;
        try {
          corps = JSON.parse(texte);
        } catch (err) {}
        if (!corps) throw new Error('reponse');
        if (!corps.ok) throw new Error(corps.erreur || 'refuse');
        return corps;
      });
  }

  function el(balise, classe, texte) {
    var noeud = document.createElement(balise);
    if (classe) noeud.className = classe;
    if (texte !== undefined && texte !== null) noeud.textContent = texte;
    return noeud;
  }

  function nombre(n) {
    return Number(n || 0).toLocaleString('fr-FR');
  }

  function montant(valeurEuros) {
    return euros(Math.round((Number(valeurEuros) || 0) * 100));
  }

  function dateCourte(iso) {
    var morceaux = iso.split('-');
    var d = new Date(+morceaux[0], +morceaux[1] - 1, +morceaux[2]);
    return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
  }

  function carte(titre, enfant) {
    var bloc = el('section', 'ce-admin__carte');
    bloc.appendChild(el('h3', null, titre));
    bloc.appendChild(enfant);
    return bloc;
  }

  function vide(texte) {
    return el('p', 'ce-admin__vide', texte || 'Aucune donnée sur cette période.');
  }

  /* Classement : libellé, barre proportionnelle au premier, valeur */
  function classement(lignes, libelle, valeurLigne, complement) {
    if (!lignes.length) return vide();
    var max = valeurLigne(lignes[0]) || 1;
    var liste = el('ol', 'ce-admin__classement');
    lignes.forEach(function (ligne) {
      var item = el('li');
      var tete = el('div', 'ce-admin__classement-tete');
      tete.appendChild(el('span', 'ce-admin__classement-nom', libelle(ligne)));
      var chiffre = el('b', null, nombre(valeurLigne(ligne)));
      if (complement) chiffre.appendChild(el('small', null, ' ' + complement(ligne)));
      tete.appendChild(chiffre);
      item.appendChild(tete);
      var piste = el('span', 'ce-admin__piste');
      var barre = el('span');
      barre.style.width = Math.max(2, (valeurLigne(ligne) / max) * 100) + '%';
      piste.appendChild(barre);
      item.appendChild(piste);
      liste.appendChild(item);
    });
    return liste;
  }

  function graphiqueVisites(serie) {
    var max = serie.reduce(function (m, j) {
      return Math.max(m, j.visites);
    }, 0);
    var totalVisites = serie.reduce(function (t, j) {
      return t + j.visites;
    }, 0);
    if (!totalVisites) return vide('Aucune visite sur cette période.');

    var bloc = el('div', 'ce-admin__graphe');
    var zone = el('div', 'ce-admin__barres');
    zone.setAttribute('role', 'img');
    zone.setAttribute(
      'aria-label',
      'Visites par jour : ' + nombre(totalVisites) + ' au total, ' + nombre(max) + ' au plus fort.'
    );
    serie.forEach(function (jour) {
      var colonne = el('span', 'ce-admin__colonne');
      colonne.tabIndex = 0;
      colonne.setAttribute(
        'data-info',
        dateCourte(jour.jour) + ' · ' + nombre(jour.visites) + ' visite' + (jour.visites > 1 ? 's' : '') +
          ' · ' + nombre(jour.visiteurs) + ' visiteur' + (jour.visiteurs > 1 ? 's' : '')
      );
      var barre = el('span', 'ce-admin__barre');
      barre.style.height = jour.visites ? Math.max(3, (jour.visites / max) * 100) + '%' : '0';
      colonne.appendChild(barre);
      zone.appendChild(colonne);
    });

    var echelle = el('div', 'ce-admin__echelle');
    echelle.appendChild(el('span', null, nombre(max)));
    echelle.appendChild(el('span', null, '0'));
    var corps = el('div', 'ce-admin__graphe-corps');
    corps.appendChild(echelle);
    corps.appendChild(zone);
    bloc.appendChild(corps);

    var axe = el('div', 'ce-admin__axe');
    axe.appendChild(el('span', null, dateCourte(serie[0].jour)));
    if (serie.length > 2) axe.appendChild(el('span', null, dateCourte(serie[Math.floor(serie.length / 2)].jour)));
    axe.appendChild(el('span', null, dateCourte(serie[serie.length - 1].jour)));
    bloc.appendChild(axe);
    return bloc;
  }

  var LIBELLES_ACTIVITE = {
    visite: 'Visite du catalogue',
    acces: 'Connexion avec le mot de passe',
    refus: 'Mot de passe refusé',
    fiche: 'Fiche consultée',
    ajout: 'Ajout au bon',
    bon: 'Bon de commande ouvert',
    paiement: 'Paiement lancé'
  };

  function activite(recents) {
    if (!recents.length) return vide();
    var liste = el('ul', 'ce-admin__activite');
    recents.forEach(function (r) {
      var item = el('li');
      var texte = LIBELLES_ACTIVITE[r.type] || r.type;
      if (r.type === 'fiche') texte += ' : ' + r.produit;
      if (r.type === 'ajout') texte += ' : ' + r.produit + (r.quantite > 1 ? ' ×' + r.quantite : '');
      if (r.type === 'paiement') texte += ' : ' + montant(r.montant) + (r.detail ? ' — ' + r.detail : '');
      item.appendChild(el('span', null, texte));
      item.appendChild(
        el(
          'time',
          null,
          new Date(r.date).toLocaleString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
        )
      );
      liste.appendChild(item);
    });
    return liste;
  }

  function afficherStats(stats) {
    var t = stats.total;
    adminCorps.innerHTML = '';

    var chiffres = el('div', 'ce-admin__chiffres');
    [
      ['Visites', nombre(t.visites), 'sessions sur le catalogue'],
      ['Visiteurs uniques', nombre(t.visiteurs), 'navigateurs différents'],
      ['Connexions', nombre(t.acces), 'mot de passe salarié saisi'],
      ['Mots de passe refusés', nombre(t.refus), 'saisies erronées'],
      ['Fiches produit vues', nombre(t.fiches), 'ouvertures de fiche'],
      ['Produits ajoutés', nombre(t.ajouts), 'unités mises dans un bon'],
      ['Bons ouverts', nombre(t.bons), 'passages sur le bon de commande'],
      ['Paiements lancés', nombre(t.paiements), montant(t.montant) + ' · ' + nombre(t.articles) + ' article' + (t.articles > 1 ? 's' : '')],
      ['Conversion', String(stats.conversion).replace('.', ',') + ' %', 'des visiteurs ont lancé un paiement']
    ].forEach(function (c) {
      var tuile = el('div', 'ce-admin__tuile');
      tuile.appendChild(el('span', 'ce-admin__tuile-titre', c[0]));
      tuile.appendChild(el('b', null, c[1]));
      tuile.appendChild(el('small', null, c[2]));
      chiffres.appendChild(tuile);
    });
    adminCorps.appendChild(chiffres);

    adminCorps.appendChild(carte('Visites par jour', graphiqueVisites(stats.parJour || [])));

    var grille = el('div', 'ce-admin__grille');
    grille.appendChild(
      carte(
        'Produits les plus consultés',
        classement(
          stats.produitsVus || [],
          function (l) { return l.produit; },
          function (l) { return l.n; },
          function (l) { return 'vue' + (l.n > 1 ? 's' : '') + ' · ' + nombre(l.visiteurs) + ' pers.'; }
        )
      )
    );
    grille.appendChild(
      carte(
        'Produits les plus ajoutés au bon',
        classement(
          stats.produitsAjoutes || [],
          function (l) { return l.produit; },
          function (l) { return l.n; },
          function (l) { return 'unité' + (l.n > 1 ? 's' : ''); }
        )
      )
    );
    grille.appendChild(
      carte(
        'Recherches des salariés',
        classement(
          stats.recherches || [],
          function (l) { return '« ' + l.terme + ' »'; },
          function (l) { return l.n; },
          function () { return 'fois'; }
        )
      )
    );
    grille.appendChild(
      carte(
        'Entreprises / CSE (paiements lancés)',
        classement(
          stats.entreprises || [],
          function (l) { return l.nom; },
          function (l) { return l.paiements; },
          function (l) { return 'paiement' + (l.paiements > 1 ? 's' : '') + ' · ' + montant(l.montant); }
        )
      )
    );
    var a = stats.appareils || {};
    var appareils = [
      { nom: 'Téléphone', n: a.mobile || 0 },
      { nom: 'Ordinateur', n: a.ordinateur || 0 },
      { nom: 'Tablette', n: a.tablette || 0 }
    ]
      .filter(function (l) { return l.n; })
      .sort(function (x, y) { return y.n - x.n; });
    grille.appendChild(
      carte(
        'Appareils utilisés',
        classement(appareils, function (l) { return l.nom; }, function (l) { return l.n; }, function (l) {
          return 'visite' + (l.n > 1 ? 's' : '');
        })
      )
    );
    grille.appendChild(carte('Activité récente', activite(stats.recents || [])));
    adminCorps.appendChild(grille);

    if (adminMaj) {
      adminMaj.textContent =
        'Mis à jour le ' +
        new Date(stats.genereLe || Date.now()).toLocaleString('fr-FR', {
          day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit'
        }) +
        '. Cet appareil n’est pas compté dans les statistiques.';
    }
    if (adminClasseur && stats.classeur) {
      adminClasseur.href = stats.classeur;
      adminClasseur.hidden = false;
    }
  }

  function chargerStats() {
    var cle = cleAdmin || lire('sessionStorage', CLE_ADMIN_SESSION);
    if (adminErreur) adminErreur.hidden = true;
    if (!cle) {
      if (adminErreur) {
        adminErreur.textContent = 'Session administrateur expirée : saisissez à nouveau le mot de passe admin.';
        adminErreur.hidden = false;
      }
      return;
    }
    admin.classList.add('is-chargement');
    demanderStats(cle, joursAdmin, false)
      .then(afficherStats)
      .catch(function (erreur) {
        if (!adminErreur) return;
        adminErreur.textContent =
          erreur && erreur.message === 'refuse'
            ? 'Le mot de passe administrateur a changé : reconnectez-vous.'
            : 'Impossible de charger les statistiques. Réessayez dans un instant.';
        adminErreur.hidden = false;
      })
      .then(function () {
        admin.classList.remove('is-chargement');
      });
  }

  /* ── En direct ── */
  var adminLive = racine.querySelector('[data-ce-admin-live]');
  var minuteurLive = null;
  var NOMS_APPAREILS = { mobile: 'Téléphone', tablette: 'Tablette', ordinateur: 'Ordinateur' };

  function dureeDepuis(ms) {
    var min = Math.floor(ms / 60000);
    if (min < 1) return 'moins d\u2019une minute';
    if (min < 60) return min + ' min';
    return Math.floor(min / 60) + ' h ' + ('0' + (min % 60)).slice(-2);
  }

  function afficherLive(live) {
    if (!adminLive) return;
    adminLive.innerHTML = '';
    var n = live.sessions.length;

    var tete = el('div', 'ce-admin__live-tete');
    var pastille = el('span', 'ce-admin__live-point' + (n ? ' is-actif' : ''));
    pastille.setAttribute('aria-hidden', 'true');
    tete.appendChild(pastille);
    var titre = el('h3', null, 'En direct');
    tete.appendChild(titre);
    tete.appendChild(
      el(
        'p',
        'ce-admin__live-compte',
        n
          ? n + ' session' + (n > 1 ? 's' : '') + ' active' + (n > 1 ? 's' : '') +
            ' · ' + live.visiteurs + ' personne' + (live.visiteurs > 1 ? 's' : '')
          : 'Personne sur le catalogue en ce moment'
      )
    );
    adminLive.appendChild(tete);

    if (n) {
      var liste = el('ul', 'ce-admin__live-liste');
      var maintenant = live.genereLe || Date.now();
      live.sessions.forEach(function (x) {
        var item = el('li');
        item.appendChild(el('span', 'ce-admin__live-appareil', NOMS_APPAREILS[x.appareil] || 'Appareil'));
        item.appendChild(el('span', 'ce-admin__live-etat', x.etat || 'Parcourt le catalogue'));
        item.appendChild(el('time', null, 'depuis ' + dureeDepuis(maintenant - x.debut)));
        liste.appendChild(item);
      });
      adminLive.appendChild(liste);
    }
    adminLive.appendChild(el('p', 'ce-admin__live-note', 'Actualisé toutes les 15 secondes.'));
  }

  function chargerLive() {
    var cle = cleAdmin || lire('sessionStorage', CLE_ADMIN_SESSION);
    if (!cle || !adminLive || admin.hidden || document.visibilityState !== 'visible') return;
    appelAdmin({ action: 'live', cle: cle })
      .then(afficherLive)
      .catch(function () {
        adminLive.innerHTML = '';
        adminLive.appendChild(el('p', 'ce-admin__vide', 'Vue en direct indisponible pour le moment.'));
      });
  }

  /* Retour sur l'onglet : on n'attend pas le prochain tour de 15 s */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && admin && !admin.hidden) chargerLive();
  });

  function demarrerLive() {
    clearInterval(minuteurLive);
    chargerLive();
    minuteurLive = setInterval(chargerLive, 15000);
  }

  function ouvrirAdmin(stats) {
    if (!admin) return;
    admin.hidden = false;
    demarrerLive();
    document.documentElement.classList.add('ce-admin-ouvert');
    montrerDeclencheurs(true);
    periodes.forEach(function (b) {
      b.setAttribute('aria-pressed', String(+b.getAttribute('data-ce-admin-jours') === joursAdmin));
    });
    if (stats && stats.jours === joursAdmin) afficherStats(stats);
    else chargerStats();
    var fermer = admin.querySelector('[data-ce-admin-fermer]');
    if (fermer) fermer.focus({ preventScroll: true });
  }

  function fermerAdmin() {
    if (!admin) return;
    admin.hidden = true;
    clearInterval(minuteurLive);
    document.documentElement.classList.remove('ce-admin-ouvert');
  }

  /* Depuis un appareil où l'accès salarié est déjà mémorisé, le portail ne
     s'affiche plus : ce lien le rouvre pour saisir le mot de passe admin. */
  var lienPortailAdmin = racine.querySelector('[data-ce-admin-portail]');
  if (lienPortailAdmin) {
    lienPortailAdmin.addEventListener('click', function () {
      if (cleAdmin) return ouvrirAdmin();
      if (!portail) return;
      contenu.hidden = true;
      portail.hidden = false;
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      var champ = portail.querySelector('[data-ce-mdp]');
      if (champ) {
        champ.value = '';
        champ.focus({ preventScroll: true });
      }
    });
  }

  if (admin) {
    if (cleAdmin) montrerDeclencheurs(true);
    adminOuvrir.forEach(function (b) {
      b.addEventListener('click', function () {
        ouvrirAdmin();
      });
    });

    admin.addEventListener('click', function (ev) {
      var periode = ev.target.closest('[data-ce-admin-jours]');
      if (periode) {
        joursAdmin = +periode.getAttribute('data-ce-admin-jours');
        periodes.forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === periode));
        });
        chargerStats();
      } else if (ev.target.closest('[data-ce-admin-actualiser]')) {
        chargerStats();
        chargerLive();
      } else if (ev.target.closest('[data-ce-admin-deconnexion]')) {
        cleAdmin = null;
        ecrire('sessionStorage', CLE_ADMIN_SESSION, null);
        montrerDeclencheurs(false);
        fermerAdmin();
      } else if (ev.target.closest('[data-ce-admin-fermer]') || ev.target === admin) {
        fermerAdmin();
      }
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !admin.hidden) fermerAdmin();
    });
  }
})();

